module.exports = __webpack_public_path__ + "select-loan-type-modal-bg.6491853.png";